export default __webpack_public_path__ + "static/preview-c84162d1dcddec2c631eaa5e9fab132f.png";